import { render, staticRenderFns } from "./ProductNotAvailable.vue?vue&type=template&id=0c479fac"
import script from "./ProductNotAvailable.vue?vue&type=script&lang=js"
export * from "./ProductNotAvailable.vue?vue&type=script&lang=js"
import style0 from "./ProductNotAvailable.vue?vue&type=style&index=0&id=0c479fac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports